export const CIFS_DEFAULT_PORT = "40445";

const NFS_PARAMS = "rw,nolock,soft";

export const buildMount = ({ type, ip, path, username, password, port }) =>
  type === "nfs"
    ? {
        mountparams: port ? `${NFS_PARAMS},port=${port}` : NFS_PARAMS,
        mountpoint: `${ip}:${path}`,
      }
    : {
        mountparams: `vers=3.1.1,uid=1000,gid=1000,rw,username=${username},password=${password},port=${port}`,
        mountpoint: `//${ip}${path}`,
      };

export const parseMount = ({ mounttype, mountpoint = "", mountparams = "" }) => {
  const params = {};
  mountparams.split(",").forEach((item) => {
    const i = item.indexOf("=");
    if (i > 0) params[item.slice(0, i)] = item.slice(i + 1);
  });
  const legacyNfsPort =
    mounttype === "nfs" && mountpoint.startsWith("//") && params.port === CIFS_DEFAULT_PORT;
  const match = mountpoint.match(/^\/\/([^\/]+)(\/.*)$/) || mountpoint.match(/^([^\/:]+):(\/.*)$/);
  return {
    ip: match?.[1] ?? "",
    path: match?.[2] ?? "",
    username: params.username ?? "",
    password: params.password ?? "",
    port: legacyNfsPort ? "" : params.port ?? (mounttype === "nfs" ? "" : CIFS_DEFAULT_PORT),
  };
};
